import React, { Component } from 'react';
import styled from 'styled-components';
import { Button } from 'antd';
import { withRouter } from 'react-router-dom';
import { ArrowLeftOutlined } from '@ant-design/icons';

const StyledToolbar = styled.div`
    background: #fafafa;
    padding: 15px;
    display: flex;
    align-items: center;
    border: 1px solid #e8e8e8;
    h1 {
        margin-bottom: 0;
        margin-left: 15px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }
`;

export const ToolbarTitle = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
`;

class Toolbar extends Component {
    goBack = () => {
        const { history, backUrl, onlyBackUrl } = this.props;

        if (history.length <= 2 || onlyBackUrl) {
            history.replace(backUrl || '/');
        } else {
            history.goBack();
        }
    }

    render() {
        const { title, hideBack } = this.props;

        return <StyledToolbar>
            { !hideBack &&
                <div>
                    <Button shape='circle' icon={<ArrowLeftOutlined />} onClick={this.goBack} />
                </div>
            }
            { title }
        </StyledToolbar>;
    }
}

export default withRouter(Toolbar);
